import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { storeChat } from "../../Services/Redux/Reducers/chatSlice";
import { formatUSD, getTitle } from "../../Services/CommonServices/helper";
import { loader } from "../../Services/Redux/Reducers/commonSlice";
import SwiperCard from "../../CommonComponents/SwiperCard";
import { SingleCategoryListProps, SingleLookTemplateDefaultProps, SingleLookTemplatePropTypes } from "../../Services/CommonServices/propTypes";
import { brandMap } from "../../Services/BrandName";
import { Cookies } from 'react-cookie-consent';

function SingleLookTemplate(props) {
  const accessedAppName = Cookies?.get('app_name') ? Cookies.get('app_name') : "";

  useEffect(() => {
    const scrollIndex = localStorage.getItem('singleLookScrollIndex');
    if (scrollIndex !== null) {
      const el = document.getElementById(`single-look-product-${scrollIndex}`);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      localStorage.removeItem('singleLookScrollIndex');
    }
  }, []);
  const dispatch = useDispatch();
  const conList = useSelector((state) => state.chat.conversationList);
  const loading = useSelector((state) => state.common.isLoader);
  const [sortedMediaByProduct, setSortedMediaByProduct] = useState({});
  const productLength = props.products?.length;

  useEffect(() => {
    if (props.index === conList.length - 1 && props.isAnswerComplete) { 
      // if(!props.stopClick) {
      //   dispatch(storeChat(true));
      // }     
      dispatch(loader(false));
    }
  }, [props.isAnswerComplete]);

  // Sort media for each product when products prop changes
  useEffect(() => {
    if (props.products && props.products.length > 0) {
      const newSortedMedia = {};
      props.products.forEach(product => {
        if (product.media && product.media.length > 0) {
          // Create a copy of the media array for sorting
          const mediaToSort = [...product.media];

          // Sort function: offbody/lifestyle images first, then videos, then other images
          mediaToSort.sort((a, b) => {
            // Offbody images should come first
            const aIsOffbody = a.url && (a.url.includes('lifestyle') || a.url.includes('_main'));
            const bIsOffbody = b.url && (b.url.includes('lifestyle') || b.url.includes('_main'));
            const aIsVideo = a.type === "Video";
            const bIsVideo = b.type === "Video";

            // First priority: offbody images
            if (aIsOffbody && !bIsOffbody) return -1; // A is offbody, B is not - A comes first
            if (!aIsOffbody && bIsOffbody) return 1;  // B is offbody, A is not - B comes first

            // Second priority: videos
            if (!aIsOffbody && !bIsOffbody) {
              // Neither are offbody images, so compare if they're videos
              if (aIsVideo && !bIsVideo) return -1; // A is video, B is not - A comes first
              if (!aIsVideo && bIsVideo) return 1;  // B is video, A is not - B comes first
            }

            // For all other cases, maintain original order
            return 0;
          });

          newSortedMedia[product.id] = mediaToSort;
        }
      });

      setSortedMediaByProduct(newSortedMedia);
    }
  }, [props.products]);

     
  const handleClick = (product, type) => {    
    let data = {}
    if (type === "quickshop") {
      data = {
        text: "",
        query: "",
        type: "quickshop",
        convoId: props.convoId,
        id: product.id,
        shopClicked: product.shopClicked,
      };
      window.open(product.url, "_blank", "noopener,noreferrer");
    } else if (type === "refresh") {
      data = {
        text: "Show me alternatives for the " + getTitle(product) + ".",
        query:
          "Show me alternatives for the product with ID " + product.id + ".",
        type: "refresh",
      };
    }
    props?.onValueChange(data);
  };

  const handlePDPNavigation = async (product) => {
    // Enhanced programmatic link creation for iPhone app compatibility
    // const a = document.createElement("a");
    // a.href = product.url;
    // a.target = '_blank';
    // a.rel = 'noopener noreferrer';
    // a.style.display = 'none';

    // // Add to DOM, click, then remove
    // document.body.appendChild(a);
    // a.click();
    // setTimeout(() => {
    //   document.body.removeChild(a);
    // }, 100);
    if (accessedAppName === "horizon") {
      try {
        await navigator.clipboard.writeText(product.url);
      } catch (err) {
        console.error("Failed to copy:", err);
      }
    } else {
      window.open(product.url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div>
      {
        (props.responseType || props.text || props.lookTitle || props.products || props.conclusion) && (
          <div
            className={`single-look-template${props.hasAltHeader ? " has-alt-header" : ""}`}
            style={{ zIndex: 1, position: "relative" }}
          > 
            <div className="row">
              <div className="col-12 look-title">{props.lookTitle}</div>
              <br />
              <div className=" col-12 look-description">{props.text}</div>
            </div>
            <div className="row">
              {props.products.map((product, index) => (
                <div key={index} id={`single-look-product-${index}`}>
                  <div className="">
                    <div style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "start",
                      width: "100%" // Ensure the container takes full width
                    }}>
                      <SwiperCard
                        product={product}
                        isSingleLook={false}
                        sortedMedia={sortedMediaByProduct[product.id]}
                        style={{ width: "100%" }} // Ensure SwiperCard takes full width of its container
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div
                      className="single-look-carousel"
                    >
                    </div>
                    <button type="button" name="pdpNavigation" className="border-0 bg-transparent text-start product-title cursor-pointer" onClick={() => handlePDPNavigation(product)}>{product.name}</button>
                    {/* <a
                      href={product.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="border-0 bg-transparent text-start product-title cursor-pointer"
                      style={{ textDecoration: "none" }}
                      onClick={() =>{ 
                        localStorage.setItem('singleLookScrollIndex', index);
                        handlePDPNavigation(product)}}
                    >
                      {product.name}
                    </a> */}
                    {/* <div className="brand_name_style">{formatLabel(product.brandName, 'SingleLookTemplate')}</div> */}
                    <div className="brand_name_style">{brandMap[product.brandName] || product.brandName}</div>
                    <div className="price">{`${formatUSD(product.price)}`}</div>
                    <div className="product-description">{product.description}</div>
                    <div className={`${index < productLength - 1 && 'single-look-btns'}`}>                     
                      <button
                        // href={product.url}
                        // target="_blank"
                        // rel="noopener noreferrer"
                        type="button"
                        name="addToBagButton"
                        className="add_to_bag_btn d-flex align-items-center justify-content-center"
                        style={{ textDecoration: "none", pointerEvents: loading ? "none" : "auto" }}
                        onClick={() => {
                          localStorage.setItem('singleLookScrollIndex', index);
                          handleClick(product, "quickshop");
                        }}
                        // aria-disabled={loading}
                        disabled={loading}
                      >
                        <img
                          src="/static/assets/shop_icon_updated.svg"
                          alt="shop_icon"
                          width="13px"
                          height="14px"
                        />
                        <span className="add_bag_text">Add to Bag</span>
                      </button>
                      {!props.stopClick && (
                        <button
                          name="similarStylesButton"
                          className="similar_styles_btn d-flex align-items-center justify-content-center"
                          disabled={loading}
                          onClick={() => handleClick(product, "refresh")}
                        >
                          <img
                            src="/static/assets/similar_icon.svg"
                            alt="similarstyle_icon"
                            width="11.85px"
                            height="11.85px"
                          />
                          <span className="see-similar-text">See Similar</span>
                        </button>
                      )}
                    </div>
                    <div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )
      }
    </div>
  );
}

SingleLookTemplate.defaultProps = {
  ...SingleLookTemplateDefaultProps,
  ...SingleCategoryListProps,
};
SingleLookTemplate.propTypes = {
  ...SingleLookTemplatePropTypes,
  ...SingleCategoryListProps,
};

export default SingleLookTemplate;
